import { render, staticRenderFns } from "./SupportNotice.vue?vue&type=template&id=22be70ff&scoped=true&"
import script from "./SupportNotice.vue?vue&type=script&lang=js&"
export * from "./SupportNotice.vue?vue&type=script&lang=js&"
import style0 from "./SupportNotice.vue?vue&type=style&index=0&id=22be70ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be70ff",
  null
  
)

export default component.exports